/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 11:43:12 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Popover from "@mui/material/Popover";
import { OSActionButton } from "ui-widgets";
import { WorkflowStagesList } from "./WorkflowStagesList";

export const WorkflowStagesFilterButton = ({ handleFilterByStage, selectedProcessStageId }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <OSActionButton variant="contained" onClick={handleClick}>
        Workflow Stages
        <KeyboardArrowDownIcon />
      </OSActionButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <WorkflowStagesList
          onEditStagesList={handleClose}
          handleFilterByStage={handleFilterByStage}
          selectedProcessStageId={selectedProcessStageId}
        />
      </Popover>
    </>
  );
};
